<template>
  <div class="ofd-box-h5">
    <!-- 头部导航 -->
    <Header type="h5" />
    <!-- 留资弹框 -->
    <UseDialog ref="infoDialog" />
    <!-- 二维码弹框 -->
    <QrCodeDialog ref="qrcodeDialog" />
    <!-- Banner -->
    <Banner
      :isPcFlag="false"
      h5Title="OFD电子保函解决方案"
      h5Desc="e签宝打造业内前沿方案，提供OFD格式电子保函生成、转换、盖章、合并、验签等全流程服务"
      :h5BgImg="h5BgImg"
      h5Btntext="了解详情"
      h5Btndesc="立即试用"
      @showDialog="showDialog"
      @showQrCodeDialog="showQrCodeDialog"
      class="h5-ofd-banner"
    />
    <!-- 适用对象 -->
    <ApplicableObjects :list="applicableObjectsList" :isPcFlag="false" />
    <!-- 解决方案 -->
    <Solution :list="solutionList" :isPcFlag="false" />
    <!-- 方案优势 -->
    <PlanAdvantage :list="planAdvantageList" :isPcFlag="false" />
    <!-- 典型案例 -->
    <TypicalCases :list="typicalCasesList" :isPcFlag="false" />
    <!-- 底部 -->
    <Footer type="h5" />
  </div>
</template>

<script>
import pageMixin from './mixins/pageMixin'
import dataList from './dataList'
import './mixins/flexible'
export default {
  mixins: [pageMixin],
  components: {
    Header: () => import('@/components/header/index.vue'),
    Banner: () => import('@/components/Banner.vue'),
    Footer: () => import('@/components/footer/index.vue'),

    // 由于样式不同，因此留资弹框和二维码弹框有单独两份文件
    UseDialog: () => import('./components/H5UseDialog.vue'),
    QrCodeDialog: () => import('./components/H5QrCodeDialog.vue'),
    ApplicableObjects: () => import('./components/ApplicableObjects.vue'),
    Solution: () => import('./components/Solution.vue'),
    PlanAdvantage: () => import('./components/PlanAdvantage.vue'),
    TypicalCases: () => import('./components/TypicalCases.vue'),
  },
  data() {
    return {
      h5BgImg: require('@/assets/images/landing-ofd/h5BannerBgImg.png'),
      applicableObjectsList: dataList.applicableObjectsList, // 适用对象数据
      solutionList: dataList.solutionList, // 解决方案数据
      planAdvantageList: dataList.planAdvantageList, // 方案优势数据
      typicalCasesList: dataList.typicalCasesList, // 典型案例数据
    }
  },
  methods: {
    // 留资弹框
    showDialog() {
      this.$refs.infoDialog.showDialog()
    },
    // 二维码弹框
    showQrCodeDialog() {
      this.$refs.qrcodeDialog.showQrCodeDialog()
    },
  },
}
</script>
<style lang="less">
.h5-ofd-banner {
  .banner-mobile {
    width: 100%;
    // height: 9.6rem;
    position: relative;
    padding-top: 100px;

    .con {
      position: absolute;
      top: 2.1333rem;
      padding: 0 0.9rem;
    }
  }
}
* > img {
  max-width: 100%;
}

a {
  font-size: 1rem;
  color: #333;
}

a:hover,
input.error {
  color: #fa465a;
}

.container {
  width: 1200px\9;
}

@media (min-width: 1200px) {
  .main {
    min-width: 1200px;
  }
}

.banner,
.banner video,
.banner .text,
.banner .text .banner_tabbox .tab_listbox,
.con,
.con1,
.con1 .con1_tab .tab_box,
.con2,
.con2 .con2_tab .tab_box,
.con3,
.con4,
.con6,
.footer {
  min-width: 0;
}

.btn {
  display: inline-block;
  padding: 6px 12px;
  margin-bottom: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.42857143;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -ms-touch-action: manipulation;
  touch-action: manipulation;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-image: none;
  border: 1px solid transparent;
  border-radius: 4px;
}
</style>
